export default "__VITE_ASSET__B5o7Qg9q__"